import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPwachromeinstall = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={25} height={24} fill='none' {...props}>
    <path
      fill='#fff'
      fillRule='evenodd'
      d='M12.903 0a12 12 0 1 0 4.514 23.125 157 157 0 0 1-1.882-4.43A7.18 7.18 0 1 1 20.139 12H25A12.04 12.04 0 0 0 12.903 0'
      clipRule='evenodd'
    />
    <path
      fill='#fff'
      fillRule='evenodd'
      d='m12.897 12.008 2.639 6.68a7.02 7.02 0 0 0 4.597-6.68z'
      clipRule='evenodd'
    />
  </svg>
);
export default SvgPwachromeinstall;
